export default __webpack_public_path__ + "static/media/170.ffb5c7da.jpg";